import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Set the worker source to use the worker from react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PDFPreviewProps {
  dropboxLink: string;
  width?: number;
}

const getEmbeddableDropboxLink = (url: string): string => {
  try {
    const newUrl = new URL(url);
    // Remove any existing raw parameter
    newUrl.searchParams.delete('raw');
    // Add raw=1 to get direct file access
    newUrl.searchParams.set('raw', '1');
    return newUrl.toString();
  } catch (error) {
    console.error('Invalid URL provided:', error);
    return url;
  }
};

const PDFPreview: React.FC<PDFPreviewProps> = ({ dropboxLink, width = 600 }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [numPages, setNumPages] = useState<number | null>(null);

  const fileUrl = getEmbeddableDropboxLink(dropboxLink);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (error: Error) => {
    setLoading(false);
    setError('Falha ao carregar o PDF. Por favor, verifique se o link está correto.');
    console.error('PDF loading error:', error);
  };

  return (
    <div style={{ 
      border: '1px solid #ccc', 
      padding: '10px',
      width: '100%',
      maxWidth: width,
      margin: '0 auto',
      backgroundColor: '#f5f5f5',
      borderRadius: '4px'
    }}>
      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            minHeight: '200px'
          }}>
            <p>Carregando PDF...</p>
          </div>
        }
      >
        {loading && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            minHeight: '200px'
          }}>
            <p>Carregando primeira página...</p>
          </div>
        )}
        
        {error && (
          <div style={{ 
            color: 'red', 
            padding: '20px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}
        
        {!loading && !error && numPages && (
          <Page 
            pageNumber={1} 
            width={width} 
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        )}
      </Document>
    </div>
  );
};

export { PDFPreview };
